import React, { useEffect, useState } from 'react';
import { Auth } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import QS from 'query-string';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Button, Flex, Label, Pane, Text, TextInput } from '@leverege/ui-elements';
import classnames from 'classnames';
import { FieldErrorsComponent, LoadingComponent, LogoComponent } from '@leverege/api-ui-login';
import TemporaryUserForbiddenScreen from "./TemporaryUserForbiddenScreen.js";
import S from './TemporaryUserLoginScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.temporaryUser.LoginScreen');
function TemporaryUserLoginScreen(props) {
  const {
    location,
    login,
    redirect,
    variant = 'temporaryUserLoginPane|loginPane',
    labelVariant = 'loginHeader',
    loginLogoVariant = 'loginLogo',
    passwordVariant = 'password|formInput',
    usernameVariant = 'loginUser',
    displayLogo = false,
    className,
    labelClassName,
    passwordClassName,
    submitClassName,
    PLogoComponent = LogoComponent
  } = props;
  const [error, setError] = useState();
  const q = QS.parse(location.search);
  const [username] = useState(q?.username || '');
  const [accessCode, setAccessCode] = useState(q?.accessCode || '');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const autoLogin = async () => {
      setIsLoading(true);
      const q = QS.parse(location.search);
      if (q.accessCode && q.username) {
        try {
          await login(q.username, q.accessCode);
          setIsLoggedIn(true);
          redirect('/');
        } catch (err) {
          setError(err);
        }
      } else if (!q.accessCode && !q.username) {
        // redirect to regular login
        redirect('/');
      }
      setIsLoading(false);
    };
    autoLogin();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const onSetAccessCode = evt => setAccessCode(evt.value);
  const onSubmit = async () => {
    setIsLoading(true);
    if (!accessCode) {
      setErrors({
        accessCode: t('accessCodeRequired')
      });
    }
    try {
      await login(q.username, accessCode);
      setIsLoggedIn(true);
      redirect('/');
    } catch (err) {
      if (err.code !== 'temporaryUser.invalidUsernameAccessCode') {
        setError(err);
      } else {
        setErrors({
          accessCode: t(err.code, t('accessCodeError'))
        });
      }
    }
    setIsLoading(false);
  };
  if (error) {
    return /*#__PURE__*/_jsx(TemporaryUserForbiddenScreen, {
      error: error
    });
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "loginBackground",
    style: {
      width: '100%',
      height: '100%'
    },
    children: /*#__PURE__*/_jsx(Flex, {
      direction: "row",
      align: "center",
      justify: "center",
      vFill: true,
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: variant,
        className: classnames(className, S.pane),
        layout: "flex:colL",
        children: [(isLoggedIn || isLoading) && /*#__PURE__*/_jsx("div", {
          className: S.blocker,
          children: /*#__PURE__*/_jsx(LoadingComponent, {
            color: "var(--color-brand500)",
            style: {
              position: 'absolute',
              top: '50%',
              left: '50%'
            }
          })
        }), displayLogo && PLogoComponent ? /*#__PURE__*/_jsx(PLogoComponent, {
          variant: loginLogoVariant
        }) : null, /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: t('title')
          }), /*#__PURE__*/_jsx(Text, {
            variant: "formBody",
            children: t('formHint')
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: labelVariant,
            className: labelClassName,
            children: t('usernameLabel')
          }), /*#__PURE__*/_jsx(TextInput, {
            variant: usernameVariant,
            className: passwordClassName,
            value: username.includes(':') ? username.split(':').at(-1) : username,
            hint: t('usernameHint'),
            disabled: true
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: labelVariant,
            className: labelClassName,
            children: t('accessCodeLabel')
          }), /*#__PURE__*/_jsx(TextInput, {
            variant: passwordVariant,
            className: passwordClassName,
            password: true,
            showPasswordIcon: tIcon('icon.showPassword', 'fa fa-fw fa-eye'),
            value: accessCode,
            alwaysFireOnReturn: true,
            hint: t('accessCodeHint'),
            onChange: onSetAccessCode,
            error: !!errors.accessCode
          }), /*#__PURE__*/_jsx(FieldErrorsComponent, {
            errors: [errors.accessCode]
          })]
        }), /*#__PURE__*/_jsx(Button, {
          className: submitClassName,
          type: "submit",
          onClick: onSubmit,
          children: t('submit')
        })]
      })
    })
  });
}
export default connect(state => ({
  auth: state.auth
}), dispatch => ({
  login: (user, pass) => {
    return dispatch(Auth.login(user, pass, null, {
      userType: 'temporary'
    }));
  },
  redirect: location => {
    return dispatch(push(location));
  }
}))(TemporaryUserLoginScreen);